module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("learn")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_c('h3', {
    staticClass: "h-sm category"
  }, [_vm._v("600state")])]), _c('h1', {
    staticClass: "h-xl",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _c('div', {
    staticClass: "author-date"
  }, [_c('h4', {
    staticClass: "h-md author"
  }, [_vm._v(_vm._s(_vm.author))]), _c('h4', {
    staticClass: "h-md date"
  }, [_vm._v(_vm._s(_vm.date))])]), _c('h4', {
    staticClass: "h-sm share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.hero.url,
      "alt": _vm.heroCaption
    }
  })]), (_vm.captions) ? _c('p', {
    staticClass: "heroCaptions body-captions",
    domProps: {
      "innerHTML": _vm._s(_vm.captions)
    }
  }) : _vm._e()]), (_vm.hero.url) ? _c('div', {
    staticClass: "col-5_xs-12",
    attrs: {
      "data-push-left": "off-4_xs-0"
    }
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related exhibitions")])]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedExhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'exhibition-single',
          params: {
            year: _vm.year(exhibition),
            id: exhibition.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(exhibition.content.teaser))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(_vm.relatedExhibitionDate(exhibition)))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related articles")])]) : _vm._e(), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedArticles), function(article) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            article: article.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(article))
      }
    }), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(article.content.teaser))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e()])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160e173e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Article.vue
// module id = 229
// module chunks = 1